import React, { Component } from 'react';
import { cloneDeep, isEqual } from 'lodash';
import { getClass } from '../../../utils/component-helpers';
import MerchantLogo from './merchant-logo';

import './merchant-carousel.scss';

class MerchantCarousel extends Component {
  constructor(props) {
    super(props);

    this.carouselContainer = null;
    this.state = {
      showLeftArrow: false,
      showRightArrow: true,
    };

    this.onResize = this.onResize.bind(this);
  }

  componentDidMount() {
    if (this.carouselContainer) this.updateCarouselArrowStates();

    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  componentDidUpdate(prevProps) {
    /*
     * Account for carousel size change due to hidden merchants reappearing
     * when switching between Cart Explorer / Search Trends
     */
    if (prevProps.insightsType !== this.props.insightsType) {
      if (this.carouselContainer) this.updateCarouselArrowStates();
    } else if (
      !isEqual(prevProps.merchants, this.props.merchants) &&
      this.props.insightsType === 'product-research'
    ) {
      this.viewFirstSelectedMerchant();
    }
  }

  onResize() {
    window.setTimeout(this.updateCarouselArrowStates(), 200);
  }

  viewFirstSelectedMerchant() {
    const { merchants } = this.props;
    const merchant = merchants.some(merch => merch.selected)
      ? merchants.find(merch => merch.selected)
      : merchants[0];

    if (this[merchant.slug].current && this[merchant.slug].current.scrollIntoView) {
      this[merchant.slug].current.scrollIntoView();
    }
  }

  /* Logic functions */
  selectMerchant(slug) {
    let newMerchants = cloneDeep(this.props.merchants);
    if (this.props.insightsType === 'product-research') {
      newMerchants.map(merch => (merch.selected = false));
    }
    /*
     * Select merchant by slug instead of index because
     * merchants get re-ordered in the carousel.
     */
    newMerchants.map(merchant => {
      if (merchant.slug === slug) {
        merchant.selected = !merchant.selected;
      }
      return merchant;
    });

    // If no merchants selected, select all merchants instead
    if (newMerchants && !newMerchants.filter(merch => merch.selected).length) {
      newMerchants = newMerchants.map(merch => {
        merch.selected = true;
        return merch;
      });
    }

    this.props.updateMerchants(newMerchants, true);
  }

  sortMerchants(merchants) {
    // Shift selected merchants to the left of the array
    const selectedMerchants = [];
    const unselectedMerchants = [];

    merchants.forEach(merchant => {
      if (merchant.selected) {
        selectedMerchants.push(merchant);
      } else {
        unselectedMerchants.push(merchant);
      }
    });

    return selectedMerchants.concat(unselectedMerchants);
  }

  /* Helper functions */
  updateCarouselArrowStates() {
    let showLeftArrow = true;
    let showRightArrow = true;

    const { scrollWidth } = this.carouselContainer;
    const { clientWidth } = this.carouselContainer;
    const { scrollLeft } = this.carouselContainer;
    const carouselWidth = scrollWidth - clientWidth;

    if (scrollLeft === 0) {
      showLeftArrow = false;
    }
    if (
      (Math.ceil(scrollLeft) === carouselWidth || scrollWidth === clientWidth) &&
      carouselWidth > 0
    ) {
      showRightArrow = false;
    }

    this.setState({ showLeftArrow, showRightArrow });
  }

  scrollCarousel(direction) {
    const distance = 500;
    const multiple = direction === 'left' ? -1 : 1;
    this.carouselContainer.scrollBy(distance * multiple, 0);
  }

  render() {
    /*
     * Only apply sorting to the render so it doesn't affect
     * the order of this.props.merchants
     */
    const sortedMerchants = this.sortMerchants(this.props.merchants);
    const merchants =
      this.props.insightsType === 'product-research' ? this.props.merchants : sortedMerchants;

    const merchantLogos = merchants.map(merchant => {
      const { slug } = merchant;
      this[slug] = React.createRef();
      return (
        <MerchantLogo
          key={slug}
          ref={this[slug]}
          merchant={merchant}
          selectMerchant={this.selectMerchant.bind(this)}
          insightsType={this.props.insightsType}
          resetCarousel={this.props.resetCarousel}
        />
      );
    });
    const arrowLeft =
      this.props.insightsType !== 'product-research' ? (
        <div
          className={getClass('arrow left', { show: this.state.showLeftArrow })}
          onClick={() => this.scrollCarousel('left')}
        ></div>
      ) : (
        <div
          className={getClass('arrow-container', { show: this.state.showLeftArrow })}
          onClick={() => this.scrollCarousel('left')}
        >
          <div className="arrow left show"></div>
        </div>
      );

    const arrowRight =
      this.props.insightsType !== 'product-research' ? (
        <div
          className={getClass('arrow right', { show: this.state.showRightArrow })}
          onClick={() => this.scrollCarousel('right')}
        ></div>
      ) : (
        <div
          className={getClass('arrow-container', { show: this.state.showRightArrow })}
          onClick={() => this.scrollCarousel('right')}
        >
          <div className="arrow right show"></div>
        </div>
      );

    return (
      <div className={`merchant-carousel-container ${this.props.insightsType}`}>
        {arrowLeft}
        <div
          className={`merchant-carousel ${!this.state.showLeftArrow ? 'no-left-arrow' : ''}`}
          ref={node => (this.carouselContainer = node)}
          onScroll={() => this.updateCarouselArrowStates()}
        >
          {merchantLogos}
        </div>
        {arrowRight}
      </div>
    );
  }
}

export default MerchantCarousel;
